import React, { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { motion } from 'framer-motion';
import PageHero from '../components/PageHero';
import FaqAccordion from '../components/FaqAccordion';

const Contact: React.FC = () => {
  const { t } = useTranslation('contact');

  const faqItems = useMemo(
    () =>
      [1, 2, 3, 4, 5, 6, 7, 8].map((n) => ({
        question: t(`faq.q${n}.question`),
        answer: t(`faq.q${n}.answer`),
      })),
    [t]
  );

  return (
    <div className="min-h-screen pt-24">
      <section className="page-section relative">
        <div className="container mx-auto">
          <PageHero
            eyebrow={t('heroEyebrow')}
            title={t('heroTitle')}
            subtitle={t('discordDescription')}
          />
          <motion.div
            initial={{ opacity: 0, y: 24 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.65, delay: 0.15 }}
            className="page-max mt-10 text-center"
          >
            <p className="mb-3 text-xs font-semibold uppercase tracking-widest text-primary-400/90">
              {t('discordSectionTitle')}
            </p>
            <div className="mx-auto my-8 max-w-2xl rounded-2xl border border-primary-500/25 bg-dark-800/40 px-6 py-4 text-left text-sm leading-relaxed text-primary-200/95 shadow-inner ring-1 ring-dark-600/60 md:text-base">
              {t('scamWarning')}
            </div>
            <button
              type="button"
              aria-disabled="true"
              className="inline-flex cursor-not-allowed items-center rounded-xl bg-gradient-to-r from-dark-600 to-dark-700 px-8 py-4 font-semibold text-dark-300 opacity-60 shadow-lg"
            >
              {t('discordSoon')}
            </button>
          </motion.div>
        </div>
      </section>

      <section className="page-section border-t border-primary-500/10 bg-[#14082a]/50">
        <div className="container mx-auto">
          <motion.div
            initial={{ opacity: 0, y: 40 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.75 }}
            className="page-max"
          >
            <FaqAccordion id="faq" title={t('faqTitle')} items={faqItems} defaultOpenIndex={0} />
          </motion.div>
        </div>
      </section>
    </div>
  );
};

export default Contact;
